module.exports = __webpack_public_path__ + "img/klugar-logo.7ec8d63b.png";